angular.module('autoremind.communications')
    .directive('communicationsTargetLatepaymentar3', ['$http', '$filter', '$sanitize', 'dialogs', 'logger', 'userProfile', 'csvImport', 'accountService', 'jobService', 'jobServiceDowngraded', 'storeDowngraded',
    function ($http, $filter, $sanitize, dialogs, logger, userProfile, csvImport, accountService, jobService, jobServiceDowngraded, storeDowngraded) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-latepaymentar3.html',
            link: function ($scope) {
                // Initialize
                $scope.viewModel = {}; // Needed for eg. allRows binding to correct scope
                $scope.csvImport = csvImport; // Making the service available from the view
                $scope.hasContent = false;
                $scope.inputfile = csvImport.inputFile;
                $scope.filename = csvImport.filename;
                $scope.rowSelected = null;
                $scope.type = 'latepayment';
                csvImport.fieldSeparator = ',';
                $scope.fieldSeparator = csvImport.fieldSeparator;
                $scope.stopOnErrors = false;
                $scope.columnStatus = 0; // This will be set when parsing the file - to one column after the last column in the file
                $scope.importState = {
                    'buttonLabel': 'Reload',
                    'busy': true //NOTE: Lock the button until first time a file is selected - TODO: Find better solution that checks if a file is selected?
                };
                csvImport.reset();
                $scope.countryPhonePrefix = 1;
                $scope.uploadFileSelected = function ($files) {
                    var file = angular.isDefined($files[0]) ? $files[0] : $files;
                    $scope.inputFile = file;
                    if ($scope.job.data.jobDescription === '') {
                        $scope.job.data.jobDescription = 'Imported: ' + file.name;
                    }
                    $scope.csvUpload(file);
                };
                /**
                 * Starts sending messages row by row - destinator by destinator
                 * Since the sending is async we'll iterate on the server response
                 */
                $scope.sendMessages = function (message) {
                    logger.debug('CSV sendMessage start');
                    if (!$scope.checkIfAnyCheckboxesSelected()) {
                        return;
                    }
                    $scope.destinatorIndex = 1;
                    $scope.countryPhonePrefix = 1;
                    $scope.rowIndex = 0;
                    if ($scope.rowIndex >= csvImport.fileData.length) {
                        return;
                    }
                    var dialog = dialogs.confirm('Confirm', 'You are about to send to ' + $scope.getCountCheckedRows() + ' recipient(s). Are you sure?');
                    dialog.result.then(function (button) {
                        // Yes
                        $scope.startSending();
                    }, function (button) {
                        // Cancel
                    });
                };
                $scope.checkIfAnyCheckboxesSelected = function () {
                    var foundChecked = false;
                    for (var i = 0; i < csvImport.fileData.length; i++) {
                        var checkbox = document.getElementById('rowSelected' + i);
                        if (checkbox.checked) {
                            foundChecked = true;
                            break;
                        }
                    }
                    if (!foundChecked) {
                        dialogs.notify('Note', 'No rows selected!');
                        return false;
                    }
                    return true;
                };
                $scope.getCountCheckedRows = function () {
                    var rows = document.getElementsByName('rowSelected');
                    var count = 0;
                    for (var i = 0; i < csvImport.fileData.length; i++) {
                        var checkbox = document.getElementById('rowSelected' + i);
                        if (checkbox.checked) {
                            count++;
                        }
                    }
                    return count;
                };
                $scope.destinatorTypeToIndex = function (destinatortype) {
                    switch (destinatortype) {
                        case 'home':
                            return 1;
                        case 'cell':
                            return 2;
                        case 'email':
                            return 3;
                    }
                };
                $scope.startSending = function () {
                    $scope.job.data.jobState = 'manual';
                    if ($scope.job.jobId === undefined) {
                        // Ensure the template model is up-to-date (or job.save will overwrite with default model)
                        $scope.updateTemplateModelBeforeSaving();
                        $scope.job.save().then(
                        // Saving success
                        function (job) {
                            $scope.job.editable = false; // Should NOT limit checking/unchecking persons
                            $scope.sendNextRow();
                        }, 
                        // Saving failed
                        function () {
                            // Saving failed (e.g. no name) so revert to draft state so it can be edited again
                            $scope.job.data.jobState = 'failed'; // TODO: This is never reached
                        });
                        return;
                    }
                    console.log('Restarting already saved job: jobId:', $scope.job.jobId);
                    // Restart already saved job
                    $scope.sendNextRow();
                };
                $scope.getPhoneMediaLetter = function (destinatorType) {
                    if (destinatorType === 'email') {
                        return '';
                    }
                    var parts = destinatorType.split('-');
                    if (parts[0] === 'voice') {
                        return 'V:';
                    }
                    if (parts[0] === 'sms') {
                        return 'T:';
                    }
                };
                /**
                 * Sending one row and on server response call itself to send next row until all rows are handled
                 * It will only send rows with checkboxes checked.
                 */
                $scope.sendNextRow = function () {
                    var checkbox = document.getElementById('rowSelected' + $scope.rowIndex);
                    $scope.rowSelected = checkbox;
                    if (checkbox.checked) {
                        if ($scope.destinatorIndex === 1) {
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = 'Sending';
                        }
                        //var firstName = $filter($scope.firstNameFilter)(csvImport.fileData[$scope.rowIndex][csvImport.columnPatientName]);
                        // TODO: allow getting csvImport.fileData[$scope.rowIndex][csvImport.columnPatientLastName] if in CSV file
                        $scope.handleSendRulesForRow(csvImport.fileData[$scope.rowIndex][csvImport.columnPatientName], $scope.rowIndex, csvImport.fileData[$scope.rowIndex][$scope.columnStatusDetail])
                            .subscribe(function (results) {
                            // All sendLatepaymentMessage calls completed
                            console.log('All messages for row ' + $scope.rowIndex + ' sent:', results);
                            csvImport.fileData[$scope.rowIndex][$scope.columnStatus] = $scope.currentRowSuccesses <= 0 ? 'Failed' : 'Sent';
                            $scope.rowIndex++;
                            if ($scope.rowIndex < csvImport.fileData.length) {
                                $scope.sendNextRow();
                            }
                            else {
                                $scope.viewModel.allRows = false;
                                //$scope.viewModel.allRows = {option : {}};
                                $scope.$apply();
                            }
                        }, function (error) {
                            console.error('Error processing destinators:', error);
                        });
                        return;
                    }
                    // If checkbox not checked
                    // Handle next row
                    $scope.rowIndex++;
                    if ($scope.rowIndex < csvImport.fileData.length) {
                        $scope.sendNextRow();
                    }
                };
                $scope.getDestinatorByTypeFromImport = function (destinatorType, rowIndex) {
                    var destinatorTypeIndex = $scope.destinatorTypeToIndex(destinatorType);
                    return csvImport.fileData[$scope.rowIndex][csvImport.columnDestinatorPhone[destinatorTypeIndex]];
                };
                // TODO: Should we limit the UI to only cell and home phone as the old UI?
                $scope.getMediaType = function (destinatorType) {
                    if (destinatorType === 'email') {
                        return 'email';
                    }
                    var parts = destinatorType.split('-');
                    return parts[0];
                };
                $scope.getDestinatorFromImportByType = function (destinatorType, rowIndex) {
                    if (destinatorType === 'email') {
                        var email = $scope.getDestinatorByTypeFromImport('email', rowIndex);
                        if (email !== '') {
                            console.log('email: ', email);
                            return { destinatorType: 'email', destinator: email };
                        }
                    }
                    if (destinatorType.includes('cell')) {
                        var phoneCell = $scope.getDestinatorByTypeFromImport('cell', rowIndex);
                        if (phoneCell !== '') {
                            console.log('cell: ', phoneCell);
                            return { destinatorType: destinatorType, destinator: phoneCell };
                        }
                    }
                    if (destinatorType.includes('home')) {
                        var phoneHome = $scope.getDestinatorByTypeFromImport('home', rowIndex);
                        if (phoneHome !== '') {
                            console.log('home: ', phoneHome);
                            return { destinatorType: destinatorType, destinator: phoneHome };
                        }
                    }
                    console.log('INVALID at row ' + rowIndex);
                    return null;
                };
                $scope.getFirstValidDestinator = function (rowIndex) {
                    for (var i = 0; i < 2; i++) {
                        var destinatorType = jobService.job.jobContent.sendRulesLeft[i].mediaDestinatorType;
                        var destinatorWithType = $scope.getDestinatorFromImportByType(destinatorType, rowIndex);
                        if (destinatorWithType !== null) {
                            return destinatorWithType;
                        }
                    }
                    // TODO: Handle if none
                };
                $scope.buildDestinatorsWithTypes = function (rowIndex) {
                    var destinatorsWithType = [];
                    if (jobService.job.jobContent.mediaTypeMode) {
                        var destinatorWithType = $scope.getFirstValidDestinator(rowIndex);
                        destinatorsWithType.push(destinatorWithType);
                        return destinatorsWithType;
                    }
                    Object.keys(jobService.job.jobContent.sendRulesRight).forEach(function (destinatorType) {
                        if (jobService.job.jobContent.sendRulesRight[destinatorType]) {
                            var destinatorWithType = $scope.getDestinatorFromImportByType(destinatorType, rowIndex);
                            if (destinatorWithType !== null) {
                                destinatorsWithType.push(destinatorWithType);
                            }
                        }
                    });
                    return destinatorsWithType;
                };
                // Traverse send rules and send for each destinator
                $scope.handleSendRulesForRow = function (fullName, rowIndex) {
                    logger.debug('csv handleSendRulesForRow start at row ' + rowIndex);
                    $scope.currentRowSuccesses = 0;
                    var context = {};
                    context.person = { firstName: fullName };
                    context.template = $scope.templateUpdateModel.updatedModel;
                    if (context.template.voiceMessage !== undefined && context.template.voiceMessage === 'Insert Text Here') {
                        context.template.voiceMessage = '';
                    }
                    var templateId = jobService.template.templateId;
                    var destinatorsWithTypes = $scope.buildDestinatorsWithTypes(rowIndex);
                    if (destinatorsWithTypes.length === 0) {
                        csvImport.fileData[rowIndex][$scope.columnStatus] = 'Skipped';
                        return;
                    }
                    return jobServiceDowngraded
                        .sendLatepaymentMessage(destinatorsWithTypes, 0, context, jobService.job.jobId, $scope.currentUser.userName, templateId, $scope.countryPhonePrefix, rowIndex, $scope.detailCellCallback);
                };
                $scope.detailCellCallback = function (rowIndex, destinatorType, destinator, status) {
                    if (status === 'OK') {
                        $scope.currentRowSuccesses++;
                    }
                    csvImport.fileData[rowIndex][$scope.columnStatusDetail] += ' | ' +
                        $scope.getPhoneMediaLetter(destinatorType) + destinator + ' (' + status + ')';
                    console.log('detailCellCallback[' + $scope.rowIndex + ':' + rowIndex + ': ' + destinatorType + ' : ' + destinator);
                };
                $scope.toggleAllRows = function (toggle) {
                    var t = toggle;
                    for (var i = 0; i < csvImport.fileData.length; i++) {
                        var checkbox = document.getElementById('rowSelected' + i);
                        checkbox.checked = t;
                    }
                };
                $scope.setType = function (type) {
                    $scope.type = type;
                    if ($scope.type === 'latepayment') {
                        csvImport.fieldSeparator = ',';
                    }
                    $scope.fieldSeparator = csvImport.fieldSeparator;
                };
                $scope.setType('latepayment');
                $scope.csvUpload = function (file) {
                    csvImport.type = $scope.type;
                    csvImport.columnDestinatorPhone = {};
                    csvImport.countryPhonePrefix = ''; //$scope.countryPhonePrefix;
                    csvImport.fieldSeparator = $scope.fieldSeparator;
                    $scope.columnPatientName = 0; //+20 lastname
                    csvImport.columnPatientName = 0;
                    csvImport.columnPatientLastName = -1;
                    $scope.columnDestinatorPhone = 2; //+24 cellphone
                    csvImport.columnDestinatorPhone[1] = 3; //Home
                    csvImport.columnDestinatorPhone[2] = 2; //Cell
                    csvImport.columnDestinatorPhone[3] = 1; //Email
                    $scope.firstNameFilter = 'BasicFirstNameFilter';
                    $scope.phoneNumberFilter = 'BasicPhoneNumberFilter';
                    csvImport.phoneNumberFilter = 'BasicPhoneNumberFilter';
                    csvImport.reset();
                    $scope.importState.buttonLabel = 'Loading & parsing...';
                    $scope.importState.busy = true;
                    csvImport.importAndParseFile(file, function () {
                        // Success
                        logger.debug('Imported file');
                        $scope.columnStatus = csvImport.columnStatus;
                        $scope.columnStatusDetail = csvImport.columnStatusDetail;
                        //$scope.columnDuplicateState = csvImport.columnDuplicateState; //Obsolete
                        $scope.importState.buttonLabel = 'Reload...';
                        $scope.importState.busy = false;
                        $scope.hasContent = true;
                        $scope.viewModel.allRows = false;
                        $scope.$apply();
                    }, function () {
                        // Error
                        logger.debug('Error loading file ');
                        $scope.importState.buttonLabel = 'Reload...';
                        $scope.importState.busy = false;
                        // TODO: Display error to user
                        $scope.hasContent = false;
                    });
                    var issuedReload = false;
                    // Make sure the template list is loaded at least the first time opening the view
                };
            }
        };
    }]);
//# sourceMappingURL=communications-target-latepaymentar3.js.map